import type * as React from 'react';

import { Description, FieldGroup, Switch } from '@gitbook/spine-react';

import type { PageLayoutOptionsProps } from './types';

/**
 * Options to configure sidebars (ToC, outline) visibility on a page.
 */
export function PageOptionsSidebars(props: PageLayoutOptionsProps): React.ReactElement {
    const { pageOptions, setPageOptionsUpdate } = props;
    return (
        <div className="flex flex-1 flex-col gap-2">
            <FieldGroup orientation="horizontal">
                <Description>Table of contents</Description>
                <Switch
                    value={!!pageOptions.layoutOptions.tableOfContents}
                    onValueChange={(value) =>
                        setPageOptionsUpdate({
                            layoutOptions: {
                                ...pageOptions.layoutOptions,
                                tableOfContents: value,
                            },
                        })
                    }
                />
            </FieldGroup>
            <FieldGroup orientation="horizontal">
                <Description>Page outline</Description>
                <Switch
                    value={!!pageOptions.layoutOptions.outline}
                    onValueChange={(value) =>
                        setPageOptionsUpdate({
                            layoutOptions: {
                                ...pageOptions.layoutOptions,
                                outline: value,
                            },
                        })
                    }
                />
            </FieldGroup>
        </div>
    );
}
